@import 'styles/mixins';
@import 'styles/variables';

.buttonGroup {
  display: flex;
  align-items: center;
  gap: 1px;
  border-radius: 36px;
  overflow: hidden;

  [data-autopilot-system-redesign='on'] & {
    border-radius: 0;
  }
}

[data-color-scheme='light'] {
  .buttonGroup {
    button {
      &:hover {
        background: var(--dark-4) !important;
      }
    }
  }
}

.leftButtons,
.rightButtons {
  width: 128px;
  display: flex;
}

.leftButtons {
  justify-content: flex-start;
}

.rightButtons {
  justify-content: flex-end;
}

@media (min-width: $phoneMaxWidth) {
  .buttonGroup {
    gap: 2px;
    background: var(--dark-7);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
      gap: 3px;
    }

    > :first-child {
      padding-left: 12px !important;

      [data-autopilot-system-redesign='on'] & {
        padding-left: 8px !important;
      }
    }

    > :last-child {
      padding-right: 12px !important;

      [data-autopilot-system-redesign='on'] & {
        padding-right: 8px !important;
      }
    }
  }

  [data-color-scheme='light'] {
    .buttonGroup {
      background: none;
      box-shadow: none;
    }
  }
}
